import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useReports from 'hooks/useReports';
import { observer } from 'mobx-react-lite';
import EstimateScale from 'components/EstimateScale';
import VGPlusTable from 'components/VGPlusTable';
import ConditionScale from 'components/ConditionScale';
import Charting from 'components/Charting';
import RecentlySold from 'components/RecentlySold';
import BrandTitle from 'components/common/BrandTitle';
import BackToTop from 'components/BackToTop';
import Select from 'react-select';

import RangeSlider from 'components/RangeSlider';
import MonthSlider from 'components/MonthSlider';

import TabContainer from 'components/Tabs/TabContainer';
import TabButtons from 'components/Tabs/TabButtons';

import ConditionSliders from 'components/ConditionSliders';
import { withAuctionCore } from 'agent';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useResponsive from 'hooks/useResponsive';
import npalogo from 'assets/images/npaLogo.png';
import Button from 'components/common/Button';
import {
  Brand, Header, ProWrapper, AttributesWrapper, TitleWrapper, YearMakeTitle, ModelTitle, SearchAgain, YMM, SearchAgainText, NPALogo, TabWrapper, Vin, ButtonsWrapper, SelectBox, SelectWrapper,
} from './styles';
import useStores from '../../../hooks/useStore';
import useLocalStorage from '../../../hooks/useLocalStorage';

const styles = {
  button: {
    width: '17vw',
    fontSize: 'clamp(10px,1.1vw,23px)',
  },
};

const ProLayout = observer(() => {
  /** zero based index, zero being current month. e.g. Oct = 0, Nov = 1, Dec = 2, Jan = 3 */
  const [month, setMonth] = useState(0);
  const { UIStore, UserStore } = useStores();
  const [isNativeView, setIsNativeView] = useLocalStorage('isNativeView');
  const {
    vin, year, predictionMonthsOut, conditionScore, mileage, modelName, makeName,
  } = UIStore;
  const { token } = UserStore;

  const { isLargeView } = useResponsive();
  const history = useHistory();
  const {
    loadFromStorage, resetStorage, loadingReport
  } = useReports();

  useEffect(() => {
    if (!isNativeView) {
      loadFromStorage();
    }
  }, [isNativeView]);

  const StartOver = () => {
    history.push('/');
    resetStorage();
    window.location.reload();

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage('Go Back');
    }
  };
  const handleConsignClick = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage('consign Click');
    } else {
      let consignUrl = window?.globalConfig.dealerPortal;
      consignUrl += '/MultiConsignModern.aspx';
      // let consignUrl = 'https://www.npauctions.com/MultiConsignModern.aspx';
      if (mileage) {
        consignUrl += `?mileage=${mileage}`;
      }
      if (vin) {
        consignUrl += `&vin=${vin}`;
      }
      window.open(consignUrl, '_blank', 'noopener, noreferrer');
    }
  };
  const handleDirectBuyClick = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage('DB Click');
    } else {
      let dbUrl = window?.globalConfig.directBuy;
      dbUrl += `/Account/TokenLogin?&token=${token}&programID=B4448DE2-7A32-4D6A-99CB-E1142FCB95EC`;
      // let dbUrl = `https://directbuy.npauctions.com/Account/TokenLogin?token=${token}&programID=B4448DE2-7A32-4D6A-99CB-E1142FCB95EC`;
      if (mileage) {
        dbUrl += `&mileage=${mileage}`;
      }
      if (vin) {
        dbUrl += `&vin=${vin}`;
      }
      window.open(dbUrl, '_blank', 'noopener, noreferrer');
    }
  };

  try {
    return (
      <ProWrapper>
        <Header>
          <Brand href="/search">
            <BrandTitle />
          </Brand>
          <NPALogo src={npalogo} />
        </Header>
        <TitleWrapper>
          {loadingReport && <p>Loading report</p>}
          <AttributesWrapper>
            <YMM>
              {year && makeName && <YearMakeTitle>{`${year} ${makeName}`}</YearMakeTitle>}
              {modelName && <ModelTitle>{` ${modelName}`}</ModelTitle>}
            </YMM>
            {vin && <Vin>{vin.toUpperCase()}</Vin>}
          </AttributesWrapper>
          <SearchAgain onClick={() => StartOver()}>
            <SearchAgainText>Start Over</SearchAgainText>
            <FontAwesomeIcon icon="redo-alt" style={{ fontSize: isLargeView ? 14 : 22 }} color={isLargeView ? 'white' : '#ea0709'} />
          </SearchAgain>
        </TitleWrapper>
        <EstimateScale estimate={predictionMonthsOut} />

        {conditionScore && <ConditionScale score={conditionScore} mileage={mileage} />}

        {/* <MonthSlider setMonth={setMonth} month={month} valueMonth={valueMonth} /> */}

        <TabWrapper>
          <TabButtons />

          <TabContainer id={0}>
            <ConditionSliders />
          </TabContainer>

          <TabContainer id={1}>
            <RangeSlider />
            <Charting />
          </TabContainer>

          <TabContainer id={2}>
            <RangeSlider />
            <RecentlySold />
          </TabContainer>

          <TabContainer id={3}>
            <VGPlusTable />
          </TabContainer>
        </TabWrapper>
        <ButtonsWrapper>
          <Button style={styles.button} onClick={handleConsignClick}>CLICK TO CONSIGN</Button>
          <Button style={styles.button} onClick={handleDirectBuyClick}>SUBMIT DIRECT BUY</Button>
        </ButtonsWrapper>
        <BackToTop />
      </ProWrapper>
    );
  } catch (e) {
    return <p>Error loading data</p>;
  }
});

export default withAuctionCore(ProLayout);
